import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('vericred_imports',
  '/vericred_imports',
  'vericred_import')
const reducer = generator.generate()

export default reducer
